import useCallQuality from './useCallQuality';
import useCallTimer from './useCallTimer';

import { Flex, Text } from '@amigoapp/doca-react';

const LiveKitCallHeader = ({ providerName }) => {
	const callQuality = useCallQuality();
	const callTimeLabel = useCallTimer();

	return (
		<Flex align="center" className={`call-quality call-quality--${callQuality.level}`} gap={2}>
			<span className="call-quality__dot" />
			<Text size="extra-small">{callQuality.label}</Text>
			<span className="call-quality__divider" />
			<Text className="call-quality__time" size="extra-small">{callTimeLabel}</Text>
			<span className="call-quality__divider call-quality__divider--provider" />
			<Text className="call-quality__provider" size="extra-small">{providerName}</Text>
		</Flex>
	);
};

export default LiveKitCallHeader;
